var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-menu',{staticClass:"plk_menu",attrs:{"menu":_vm.menu,"expanded":"true","collapsed":true,"hideToggle":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }